import { Typography, Select, MenuItem } from '@mui/material';
import { MaterialIcon } from '@tap/mui-ui';
import { SxProps, Theme } from '@mui/material';

export type SelectViewFieldProps = {
    value: any,
    sourceList: any[],
    selectSx?: SxProps<Theme>,
    iconSx?: SxProps<Theme>,
}

export type SelectEditFieldProps = SelectViewFieldProps & {
    defaultValue?: string,
    className?: string,
    onChange: (newValue: any) => void,
}

export const SelectViewField = ({
    value,
    sourceList,
    iconSx = {},
}: SelectViewFieldProps) => {
    const selectedValue = sourceList.find(p => p.code === value);

    if (!selectedValue)
        return <>{'-'}</>;

    return (
        <Typography>
            {selectedValue.icon && (
                <MaterialIcon
                    iconName={selectedValue.icon.name}
                    sx={{
                        fontSize: '19px',
                        marginBottom: '-4px',
                        marginRight: '6px',
                        color: selectedValue.icon.color,
                        backgroundColor: selectedValue.icon.backgroundColor,
                        ...iconSx,
                    }}
                />
            )}

            {selectedValue.name}
        </Typography>
    );
}


export const SelectEditField = ({
    value,
    sourceList,
    onChange,
    selectSx = {},
    iconSx = {},
    defaultValue,
    className,
}: SelectEditFieldProps) => {
    return (
        <Select
            className={className}
            sx={{
                width: '100%',
                ...selectSx,
            }}
            defaultValue={defaultValue}
            value={value}
            size='small'
            onChange={e => { onChange && onChange(e.target.value); }}
        >
            {sourceList.map(item => (
                <MenuItem value={item.code} key={item.code}>
                    <Typography>
                        {item.icon && (
                            <MaterialIcon
                                iconName={item.icon.name}
                                sx={{
                                    fontSize: '19px',
                                    marginTop: '2px',
                                    marginBottom: '-4px',
                                    marginRight: '6px',
                                    color: item.icon.color,
                                    backgroundColor: item.icon.backgroundColor,
                                    ...iconSx,
                                }}
                            />
                        )}
                        {item.name}
                    </Typography>
                </MenuItem>

            ))}

        </Select >
    );
}